var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-screen',{staticClass:"startRegistration",attrs:{"title":_vm.$ml.get('setPinCodeTitleReg'),"text":_vm.$ml.get('setPinCodeTextReg'),"action":_vm.nextScreen,"buttonText":_vm.$ml.get('setPinCodeButtonReg'),"titleH1":false}})}
var staticRenderFns = []

export { render, staticRenderFns }